"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Multichain = void 0;
const index_1 = require("../../utils/chains/evm/index");
class Multichain {
    constructor(baseUrl, walletType) {
        this.chains = {};
        this.walletType = walletType;
        /** all on 1inch for swap */
        // this.chains.SEPOLIA = new EVM(11155111, 'https://rpc.sepolia.org');
        this.chains.MUMBAI = new index_1.EVM(baseUrl, 80001, 'https://polygon-mumbai.blockpi.network/v1/rpc/public', 'MUMBAI', walletType); // for DID
        this.chains.ETH = new index_1.EVM(baseUrl, 1, 'https://eth.llamarpc.com', 'ETH', walletType);
        this.chains.POLYGON = new index_1.EVM(baseUrl, 137, 'https://polygon.llamarpc.com', 'POLYGON', walletType);
        this.chains.AVALANCHE = new index_1.EVM(baseUrl, 43114, 'https://avalanche-c-chain.publicnode.com', 'AVALANCHE', walletType); // Avalanche C-chain
        this.chains.ARBITRUM = new index_1.EVM(baseUrl, 42161, 'https://arbitrum-one.publicnode.com', 'ARBITRUM', walletType); // Arbitrum One
        this.chains.BINANCE = new index_1.EVM(baseUrl, 56, 'https://bsc.publicnode.com', 'BINANCE', walletType);
        this.chains.OPTIMISM = new index_1.EVM(baseUrl, 10, 'https://optimism.meowrpc.com', 'OPTIMISM', walletType);
        // this.chains.KLAYTN = new EVM(8217, 'https://klaytn.blockpi.network/v1/rpc/public');
        this.chains.FANTOM = new index_1.EVM(baseUrl, 250, 'https://fantom.publicnode.com', 'FANTOM', walletType); // Fantom Opera
        // this.chains.GNOSIS = new EVM(
        //   baseUrl,
        //   100,
        //   'https://gnosis-mainnet.public.blastapi.io',
        //   'GNOSIS',
        //   walletType
        // );
        // /** */
        // this.chains.CELO = new EVM(baseUrl, 42220, 'https://rpc.ankr.com/celo', 'CELO', walletType); // not on 1inch for swap
        // this.chains.OKX = new EVM(baseUrl, 66, 'https://exchainrpc.okex.org', 'OKX', walletType); // OKX DEX
        this.chains.FUSE = new index_1.EVM(baseUrl, 122, 'https://rpc.fuse.io/', 'FUSE', walletType);
    }
}
exports.Multichain = Multichain;
